import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../api/axiosInstance";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Groups2RoundedIcon from '@mui/icons-material/Groups2Rounded';
import useEntity from "../../../api/useEntity";
import EditModal from "../../../components/editModal/editModal";
import ChangeRolePermissions from "../../../components/changeRolePermissions/changeRolePermissions";
import moment from 'moment';
import "./roles.scss"

const Roles = () => {
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [changeAccessRights, setChangeAccessRights] = useState(false);

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get("/data/roles");
            setItems(res.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    const { item, setItem, isLoading, save } = useEntity({
        endpoint: "data/roles",
        selectedItem,
        onSuccess: () => {
            fetchData();
            setSelectedItem(null);
        }
    });

    return (
        <div className="apiKeys">
            <button className="add" onClick={() => setSelectedItem(true)}>Rolle hinzufügen</button>
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Erstellt am</th>
                            <th className="options"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((i) => (
                            <tr key={i.id}>
                                <td>{i.name}</td>
                                <td>{moment(i.createdAt).calendar()}</td>
                                <td className="options">
                                    <div className="controls">
                                        <EditOutlinedIcon onClick={() => setSelectedItem(i.id)} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {selectedItem !== null && (
                <EditModal
                    title="Rolle"
                    isLoading={isLoading}
                    item={item}
                    onClose={() => setSelectedItem(null)}
                    onSave={save}
                >
                    <div className="group">
                        <Groups2RoundedIcon />
                        <input
                            type="text"
                            required
                            value={item.name || ""}
                            placeholder="Name"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    name: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button type="submit">Speichern</button>
                            <button type="button" className="light" onClick={() => setChangeAccessRights(true)}>Rechte ändern</button>
                        </div>
                    </div>
                </EditModal>
            )}

            {changeAccessRights && (
                <ChangeRolePermissions
                    id={item.id}
                    role={item.name}
                    onClose={() => setChangeAccessRights(false)}
                />
            )}
        </div>
    )
};

export default Roles